import { Multiselect } from "multiselect-react-dropdown";
import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import {
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
// import { ExcelRenderer } from "react-excel-renderer";
export default function ServiceArea() {
  const history = useHistory();
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [pincode, setPincodes] = useState([]);
  const [allPin, setAllPin] = useState([]);
  const [uploadData, setUploadData] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);
  const [show4, setShow4] = useState(false);
  const [catDel, setCatDel] = useState(false);
  const [singlePin, setSinglePin] = useState("");
  const [singlePinArr, setSinglePinArr] = useState([]);
  const [show1, setShow1] = useState(false);
  const [name, setName] = useState("");
  const [geoData, setGeoData] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serviceCategory, setServiceCategory] = useState("");
  const [servicePincode, setServicePincode] = useState("");
  const [updateService, setUpdateService] = useState(false);
  const [addExist, setAddExist] = useState(false);
  const [addExistId, setAddExistId] = useState("");
  const [forSearch, setForSearch] = useState([]);
  const [forSearchUpload, setForSearchUpload] = useState([]);
  const [catList, setCatList] = useState([]);
  const selection2 = (selectedValues) => {
    setServiceCategory(selectedValues[0].category);
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const handleClose2 = () => {
    setShow1(false);
  };
  function getCategory() {
    let cat = [];
    axios
      .get(Baseurl.baseurl + `/go-ui/get-category`)
      .then((res) => {
        res.data.categories.map((val) => {
          cat.push({ category: val.Category, title: val.Category });
        });
        cat.push({ category: "others", title: "Others" });
        setCatList(cat);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function getData() {
    axios
      .get(Baseurl.baseurl + `/go-service-area/get-all-service-area`)
      .then((res) => {
        setSpinner(false);
        setGeoData(res.data.serviceArea);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getData();
    getCategory();
  }, []);

  function removeDuplicates(arr) {
    var counts = arr.reduce(function (counts, item) {
      counts[item] = (counts[item] || 0) + 1;
      return counts;
    }, {});
    return Object.keys(counts).reduce(function (arr, item) {
      if (counts[item] === 1) {
        arr.push(item);
      }
      if (counts[item] === 3) {
        arr.push(item);
      }
      return arr;
    }, []);
  }
  function deleteGeofence() {
    axios
      .delete(
        Baseurl.baseurl + `/go-service-area/delete-service-area/${serviceId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow4(false);
  }
  function updateCategory() {
    var serviceData = {
      Name: `${name}`,
      Category: serviceCategory,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-service-area/update-service-area/${serviceId}`,
        serviceData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getData();
        handleClose2();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function handleShow1(id, name, category) {
    setServiceId(id);
    setUpdateService(true);
    setShow1(true);
    setName(name);

    //setServiceName(name);
    setServiceCategory(category);
  }
  function handleShow2(pincode) {
    setServicePincode(pincode);
    setForSearch(pincode);
    setShow1(true);
    setUpdateService(false);
  }
  function onChangeFile(file) {
    // ExcelRenderer(file, (err, resp) => {
    //   if (err) {
    //   } else {
    //     let newRows = [];
    //     let allpin = [];
    //     resp.rows.slice(0).map((row, index) => {
    //       if (row && row != "undefined" && row != "") {
    //         allpin.push(row[1]);
    //         newRows.push({
    //           key: index,
    //           location: row[0],
    //           pincode: row[1],
    //           state: row[2],
    //           district: row[3],
    //         });
    //       }
    //     });
    //     setAllPin(allpin);
    //     setUploadData(newRows);
    //     setForSearchUpload(newRows);
    //   }
    // });
  }
  function pincodeSelect(pin) {
    setPincodes((oldArray) => oldArray.concat(pin));
  }
  function addGeofence(val) {
    if (addExist) {
      if (val == "addAll") {
        var Pincodes = {
          pincode: allPin,
        };
      } else {
        var Pincodes = {
          pincode: [...new Set(removeDuplicates(pincode))],
        };
      }
      axios
        .put(
          Baseurl.baseurl + `/go-service-area/add-new-pincode/${addExistId}`,
          Pincodes
        )
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("Updated", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            setUploadData("");
            setPincodes([]);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
          setShow(false);
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    } else {
      if (val == "addAll") {
        var Pincodes = {
          pincode: allPin,
          name: `${name}`,
          category: `${serviceCategory}`,
        };
      } else {
        var Pincodes = {
          pincode: [...new Set(removeDuplicates(pincode))],
          name: `${name}`,
          category: `${serviceCategory}`,
        };
      }
      axios
        .post(Baseurl.baseurl + `/go-service-area/add-service-area`, Pincodes)
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("Added", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            setPincodes([]);
            setUploadData("");
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
          setShow(false);
        })
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    }
  }

  function searchPincode(value) {
    let filteredData = [];
    forSearch.map((val) => {
      let pinString = val.toString();
      if (pinString.includes(value)) {
        filteredData.push(val);
      }
    });
    setServicePincode(filteredData);
  }
  function searchUpload(value) {
    let filteredData = [];
    forSearchUpload.map((val) => {
      let pinString = val.pincode.toString();
      if (
        val.location.toLowerCase().includes(value) ||
        pinString.includes(value)
      ) {
        filteredData.push(val);
      }
    });
    setUploadData(filteredData);
  }
  // function vikkitheivar(){
  //   const location = window.navigator && window.navigator.geolocation
  //   if (location) {
  //     location.getCurrentPosition((position) => {
  //       console.log("lat",position.coords.latitude)
  //       console.log("long",position.coords.longitude)

  //     }, (error) => {
  //      console.log("errrrryy")
  //     })
  //   }
  // }
  function storePincode() {
    setSinglePinArr(
      (oldArray) => oldArray.concat(singlePin),
      () => {}
    );
    setSinglePin("");
  }
  function addSinglePincodeToService() {
    var Pincodes = {
      pincode: singlePinArr,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-service-area/add-new-pincode/${addExistId}`,
        Pincodes
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setUploadData("");
          setPincodes([]);
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function removeSinglePincodeService() {
    var Pincodes = {
      pincode: [...new Set(removeDuplicates(pincode))],
    };
    axios
      .put(
        Baseurl.baseurl +
          `/go-service-area/delete-pincode-service-area/${addExistId}`,
        Pincodes
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setUploadData("");
          setPincodes([]);
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow1(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  return (
    <div className="row">
      <div className="col-xl-12 col-lg-12">
        <div
          className="card"
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <div className="card-header">
            <h4 className="card-title text-white">Serviceable Area List</h4>
            <button
              onClick={() => {
                setShow(true);
                setAddExist(false);
                setUploadData("");
              }}
              className="btn btn-primary"
            >
              Create Serviceable Area
            </button>
            {/* <button onClick={()=>{vikkitheivar()}} className="btn btn-primary">jabbbaa</button> */}
          </div>
          <Modal
            show={show4}
            onHide={() => {
              setShow4(false);
            }}
          >
            <Modal.Body>
              <h4>
                Are you sure !! you want to delete{" "}
                <text className="text-danger ml-1">{serviceName}</text>{" "}
              </h4>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => {
                  deleteGeofence();
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            size="lg"
            show={show}
            onHide={() => {
              setShow(false);
            }}
          >
            <Modal.Body>
              <div className="form-group row">
                {!addExist && (
                  <>
                    <div className="col-sm-4">
                      <label>
                        <strong>Category</strong>
                      </label>
                      <Multiselect
                        closeIcon="close"
                        options={catList}
                        displayValue="title"
                        onSelect={selection2}
                        singleSelect
                      />
                    </div>
                    <div className="col-sm-4 mb-4">
                      <label>
                        {" "}
                        <strong>Name</strong>
                      </label>
                      <input
                        value={name}
                        type="text"
                        className="form-control"
                        placeholder="Area Name"
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                  </>
                )}
                <div className="col-sm-4">
                  <label>
                    <strong>Choose file to upload</strong>
                  </label>

                  <input
                    className="mt-2"
                    id="profilePic"
                    type="file"
                    onChange={(e) => {
                      onChangeFile(e.target.files[0]);
                    }}
                  />
                </div>
              </div>
              {addExist && (
                <>
                  <div className="row">
                    <div className="col-sm-4 mb-4">
                      <label>
                        <strong>Enter Pincode Manually</strong>
                      </label>
                      <input
                        value={singlePin}
                        type="text"
                        className="form-control"
                        placeholder="Pincode"
                        maxLength={6}
                        onChange={(e) => setSinglePin(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-sm-2 mt-4">
                      <button
                        onClick={() => {
                          storePincode();
                        }}
                        className="btn btn-primary"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  {singlePinArr.length !== 0 && (
                    <>
                      <table>
                        <thead>
                          <th>Pincode</th>
                        </thead>
                        {singlePinArr.map((val) => {
                          return (
                            <tbody>
                              <tr>
                                <td>{val}</td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </table>
                      <button
                        className="btn btn-primary mt-4 mb-4"
                        onClick={() => {
                          addSinglePincodeToService();
                        }}
                      >
                        Update
                      </button>
                    </>
                  )}
                </>
              )}
              {uploadData && (
                <div
                  className="card mb-0"
                  style={{
                    color: "white",
                    background:
                      "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
                  }}
                >
                  <div className="card-header">
                    <input
                      type="text"
                      className="form-control col-sm-4 float-right"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchUpload(e.target.value);
                      }}
                    />
                    <Button
                      variant="primary"
                      onClick={() => {
                        addGeofence("addAll");
                      }}
                    >
                      ADD ALL
                    </Button>
                  </div>
                  <div className="card-body">
                    <table className="dataTable">
                      <thead>
                        <tr>
                          <th></th>
                          <th>
                            <strong className="text-white">Location</strong>
                          </th>
                          <th>
                            <strong className="text-white">Pincodes</strong>
                          </th>
                          <th>
                            <strong className="text-white">State</strong>
                          </th>
                          <th>
                            <strong className="text-white">Disticts</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {uploadData.map((val) => {
                          return (
                            <tr>
                              <td>
                                <input
                                  type="checkbox"
                                  onClick={() => pincodeSelect(val.pincode)}
                                  className="mb-3"
                                  id="checkAll"
                                  required
                                />
                              </td>
                              <td>{val.location}</td>
                              <td>{val.pincode}</td>
                              <td>{val.state}</td>
                              <td>{val.district}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              {uploadData && (
                <Button
                  variant="primary "
                  onClick={() => {
                    addGeofence("add");
                  }}
                >
                  ADD
                </Button>
              )}
            </Modal.Footer>
          </Modal>

          <Modal size="lg" show={show1} onHide={handleClose2}>
            <Modal.Body>
              <div className="card-body">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-12">
                      {updateService ? (
                        <div className="form-group row">
                          <div className="col-sm-4" id="multiselect">
                            <label>Category</label>
                            <Multiselect
                              closeIcon="close"
                              options={catList}
                              displayValue="title"
                              onSelect={selection2}
                              placeholder={serviceCategory}
                            />
                          </div>
                          <div className="col-sm-5 mb-4">
                            <label>Name</label>
                            <input
                              value={name}
                              type="text"
                              className="form-control"
                              placeholder="Area Name"
                              onChange={(e) => setName(e.target.value)}
                              required
                            />
                          </div>
                          <div className="mt-1">
                            <Link>
                              <button
                                onClick={() => {
                                  updateCategory();
                                }}
                                className="btn btn-primary ml-4 mt-3"
                              >
                                Update
                              </button>
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <>
                          <input
                            type="number"
                            className="form-control col-sm-4 float-right"
                            placeholder="Search here..."
                            onChange={(e) => {
                              searchPincode(e.target.value);
                            }}
                          />
                          <Table responsive className="table table-striped">
                            <thead>
                              <tr>
                                <th>
                                  <strong>Pincodes</strong>
                                </th>
                                <th>
                                  <strong>
                                    <button
                                      onClick={() => {
                                        if (pincode.length === 0) {
                                          swal(
                                            "Select",
                                            "please select the pincodes to delete",
                                            "error",
                                            {
                                              button: "Done",
                                              timer: 1000,
                                            }
                                          );
                                        } else {
                                          removeSinglePincodeService();
                                        }
                                      }}
                                      className="btn btn-primary float-right"
                                    >
                                      Delete
                                    </button>
                                  </strong>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {servicePincode &&
                                servicePincode.map((i) => (
                                  <tr>
                                    <td>{i}</td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        onClick={() => pincodeSelect(i)}
                                        className="p-0"
                                        id="checkAll"
                                        required
                                      />
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <div className="card-body">
            <div className="col-sm-12">
              <div id="job_data" className="dataTables_wrapper ">
                {spinner ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <Table responsive className="table text-white" id="myTable">
                    <thead>
                      <tr>
                        <th>
                          <strong>Slno.</strong>
                        </th>
                        <th>
                          <strong>NAME</strong>
                        </th>
                        <th>
                          <strong>Category</strong>
                        </th>
                        <th>
                          <strong>Update Pincode</strong>
                        </th>
                        <th>
                          <strong>Actions</strong>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {geoData &&
                        geoData.map((i, key) => (
                          <tr>
                            <td>{key + 1}</td>
                            <td>{i.Name}</td>
                            <td>{i.Category}</td>
                            {/* <td>
                              {i.Category && i.Category.map((val) => {
                                return <div>
                                 <label className="col-sm-8">{val}</label>
                                  <Link
                                onClick={() => {
                                  setShow4(true);
                                  setCatDel(true)
                                  setCat(val)
                                  setServiceId(i._id);
                                }}
                                href="#"
                                className="btn btn-danger shadow btn-xs sharp"
                              >
                                <i className="fa fa-trash"></i>
                              </Link>
                                </div>;
                              })}
                            </td> */}
                            <td>
                              {" "}
                              <Link
                                onClick={() => {
                                  setShow(true);
                                  setAddExistId(i._id);
                                  setAddExist(true);
                                  setUploadData("");
                                  setSinglePinArr([]);
                                }}
                                href="#"
                                className="btn btn-secondary shadow btn-xs sharp ml-5"
                              >
                                <i className="fa fa-plus-square"></i>
                              </Link>
                            </td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="warning"
                                  className="light sharp i-false"
                                >
                                  {svg1}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      handleShow1(i._id, i.Name, i.Category);
                                    }}
                                  >
                                    Update
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setCatDel(false);
                                      setShow4(true);
                                      setServiceId(i._id);
                                      setServiceName(i.Name);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      handleShow2(i.Pincode);
                                      setServiceId(i._id);
                                      setAddExistId(i._id);
                                      setPincodes([]);
                                    }}
                                  >
                                    View Geofence
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                            {/* <td>{i.Name }</td> */}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                )}

                {!geoData && (
                  <Alert
                    variant="success"
                    className="alert-dismissible fade show text-center"
                  >
                    Add Serviceable Area
                  </Alert>
                )}
                <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                  <div className="dataTables_info text-white">
                    Showing {activePag.current * sort + 1} to{" "}
                    {data.length > (activePag.current + 1) * sort
                      ? (activePag.current + 1) * sort
                      : data.length}{" "}
                    of {data.length} entries
                  </div>
                  <div
                    className="dataTables_paginate paging_simple_numbers"
                    id="example5_paginate"
                  >
                    <Link
                      className="paginate_button previous disabled"
                      onClick={() =>
                        activePag.current > 0 && onClick(activePag.current - 1)
                      }
                    >
                      Previous
                    </Link>
                    <span>
                      {paggination.map((number, i) => (
                        <Link
                          key={i}
                          className={`paginate_button  ${
                            activePag.current === i ? "current" : ""
                          } `}
                          onClick={() => onClick(i)}
                        >
                          {number}
                        </Link>
                      ))}
                    </span>
                    <Link
                      className="paginate_button next"
                      onClick={() => {
                        activePag.current + 1 < paggination.length &&
                          onClick(activePag.current + 1);
                      }}
                    >
                      Next
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
